import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { MessageSettings as FacilityMessageSettings } from "@/commons/services/Facilities";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### メッセージ送信設定 API 操作クラス
 */
export default class MessageSettings {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### PATCH MessageSettings
   */
  public async patch(userStore: LoginUser, requestBody: MessageSettingsPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MessageSettings, formatParams);
    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface MessageSettingsPatchModel {
  /** メッセージ送信設定 */
  messageSettings: FacilityMessageSettings;
  /** 更新日時 */
  updated: number;
}
